<template>
  <div class="product-image">
    <i
      class="favorite fa"
      :class="{
        'fa-heart': product.has_favorite,
        'fa-heart-o': !product.has_favorite,
      }"
      @click="ToggleFavorite(product)"
    ></i>
    <img
      :src="product.images.length > 0 ? product.images[0].path : ProductDefault"
      :alt="product.name"
      class="img-product"
      @click="goToProduct(product)"
    />
  </div>
  <div class="product-info">
    <div class="col col-lg-12 item-info">
      <template v-if="product.gamme_supplyvet || product.gamme">
        <label class="gamme mb-2 mx-2">{{ product.gamme_supplyvet ?? "" }}</label><br />
      </template>
      <label class="title mb-2 mx-2" @click="goToProduct(product)">{{ product.name }}</label>
    </div>
    <div class="col col-lg-12">
      <button class="btn text-white product-more mx-2 mt-3" @click.prevent="goToProduct(product)">Recommander</button>
    </div>
  </div>
</template>

<script>
  import ProductDefault from "@/assets/images/product_default.png";
  import { useProductsStore } from "@/stores/productsStore";

  export default {
    data() {
      return {
        ProductDefault,
        selectedImage: "",
        Currentproduct: null,
      };
    },
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    created() {
      // Initialisation du store de produits
      this.productsStore = useProductsStore();
    },
    methods: {
      ToggleFavorite(prod) {
        prod.has_favorite = !prod.has_favorite;
        if (prod.has_favorite) {
          this.productsStore.AddFavoriteProduct(prod);
        } else {
          this.productsStore.RemoveFavoriteProduct(prod);
        }
      },
      goToProduct(prod) {
        var slug = prod.slug;
        this.$router.push({ name: "ProductDetail", params: { slug } });
      },
    },
  };
</script>

<style scoped>
  .product-card {
    display: contents;
  }
  .product-image {
    border-radius: 10px;
    background: #fff;
    padding: 5px;
    img.img-product {
      cursor: pointer;
    }
  }
  .product-image .favorite {
    float: right;
    cursor: pointer;
  }
  .product-info {
    text-align: justify;
    padding: 5px;
    height: 100%;
    .gamme {
      font-size: 15px;
      font-weight: 300;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      text-align: left;
      color: #1e347d;
      cursor: pointer;
    }
  }
  .product-image img {
    max-width: 100%;
  }
  .product-more {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 15px;
    text-align: center;
  }
  @media (min-width: 768px) and (max-width: 1367px) {
    .product-image {
      .title {
        font-size: 14px;
      }
    }
  }
  @media (max-width: 768px) {
    .product-image {
      .title {
        font-size: 13px;
      }
    }

  }

  /******************Modal Cart***************************/
  .cart-product-card {
    text-align: left;
    .cart-product-image {
      border-radius: 10px;
      background: #fff;
    }
  }
  .cart-product-card img {
    max-width: 100%;
    border: 1px solid #efefef;
    border-radius: 10px;
  }
  .cart-product-info {
    padding: 5px;
    .gamme {
      display: block;
      font-size: 20px;
      font-weight: 300;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }
    .title {
      display: block;
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }
    .reference {
      font-size: 13px;
      color: #666666;
    }
    .desc {
      text-align: left;
      label {
        font-size: 16px;
      }
    }
    .price span {
      font-size: 18px;
    }
  }
  .btn-checkout {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  /* Responsive styles */
  @media (max-width: 992px) {

    .product-image {
      padding: 2px;
      border-radius: 8px;
    }
    .product-info {
      padding: 2px;
    }
    .product-more {
      font-size: 13px;
      padding: 6px 12px;
    }
    .title {
      font-size: 14px !important;
    }
    .gamme {
      font-size: 13px !important;
    }
  }

  @media (max-width: 600px) {
    .product-image {
      padding: 1px;
      border-radius: 6px;
    }
    .product-info {
      padding: 1px;
    }
    .product-more {
      font-size: 12px;
      padding: 4px 8px;
    }
    .title {
      font-size: 12px !important;
    }
    .gamme {
      font-size: 11px !important;
    }
    .item-info {
      margin-bottom: 4px;
    }
    .img-product {
      max-width: 80px;
      height: auto;
    }
  }
  .btn-shopping {
    border-color: #ec621a !important;
    color: #ec621a !important;
    border-radius: 76px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .btn-qt {
    color: #1e347d;
    border-color: gray !important;
    border-radius: 76px;
    text-align: center;
  }
  .title-blue {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .related-products .info .title {
    color: #1e347d;
    font-size: 15px;
    font-weight: bold;
  }

  .related-product-card {
    text-align: left;
    .related-product-image {
      border-radius: 10px;
      background: #fff;
      height: 170px;
    }
  }
  .related-product-card img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    border: 1px solid #efefef;
    border-radius: 10px;
  }
  .related-product-info {
    padding: 5px;
    .title {
      display: block;
      font-size: 15px;
      font-weight: bold;
      font-style: normal;
      color: #1e347d;
      min-height: 45px;
    }
    .sub-title {
      font-size: 17px;
    }
    .price {
      font-size: 22px !important;
    }
    .price span {
      font-size: 15px;
    }
  }
  .prod-caract {
    border: 1px solid #1e347d;
    border-radius: 76px;
    color: #1e347d;
  }
  .btn-add-cart {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
  }
</style>
